export const genres = [
  {
    name: "动作",
    slug: "action",
    icon: "ri-sword-line",
    desc: "拳拳到肉、火力全开的动作大片，追逐、爆破与对决一应俱全。",
  },
  {
    name: "喜剧",
    slug: "comedy",
    icon: "ri-emotion-laugh-line",
    desc: "轻松解压的欢乐喜剧，用最温暖的幽默承包你的整个周末。",
  },
  {
    name: "爱情",
    slug: "romance",
    icon: "ri-heart-3-line",
    desc: "关于心动与陪伴的浪漫故事，甜而不腻，治愈每一颗心。",
  },
  {
    name: "科幻",
    slug: "scifi",
    icon: "ri-rocket-2-line",
    desc: "穿越星海与未来的想象，硬核设定与宏大视效的完美结合。",
  },
  {
    name: "悬疑",
    slug: "suspense",
    icon: "ri-search-eye-line",
    desc: "层层反转、步步惊心，让你跟随线索拼出真相的拼图。",
  },
  {
    name: "动画",
    slug: "animation",
    icon: "ri-bear-smile-line",
    desc: "全年龄向的动画佳作，用想象力的画笔描绘温暖与成长。",
  },
  {
    name: "恐怖",
    slug: "horror",
    icon: "ri-ghost-2-line",
    desc: "寒意袭人的惊悚氛围，胆大者专属的心跳加速体验。",
  },
  {
    name: "剧情",
    slug: "drama",
    icon: "ri-film-line",
    desc: "细腻刻画人物与生活，在平凡故事中看见动人的力量。",
  },
  {
    name: "战争",
    slug: "war",
    icon: "ri-shield-star-line",
    desc: "硝烟与信念交织的宏大叙事，致敬那些被铭记的瞬间。",
  },
  {
    name: "奇幻",
    slug: "fantasy",
    icon: "ri-magic-line",
    desc: "龙与魔法共存的幻想世界，开启一场身临其境的冒险。",
  },
  {
    name: "犯罪",
    slug: "crime",
    icon: "ri-fingerprint-line",
    desc: "在罪与罚的边缘游走，智斗与人性博弈的高能现场。",
  },
  {
    name: "冒险",
    slug: "adventure",
    icon: "ri-compass-3-line",
    desc: "翻山越海去往未知之地，与主角一起踏上热血的旅程。",
  },
];